namespace $.$$ {

	$mol_style_define( $shm_echarts_settings, {
		flex: {
			direction: 'column',
		},
		Animation_duration_initial_label: {
			maxWidth: '30rem',
		},
		Animation_duration_update_label: {
			maxWidth: '30rem',
		},
		Animation_easing_label: {
			maxWidth: '30rem',
		},
	} )

}
